export const dashboardConstants = {
  SIDEMENU_OPEN_HANDLE: "SIDEMENU_OPEN_HANDLE",
  SIDEMENU_CLOSE_HANDLE: "SIDEMENU_CLOSE_HANDLE",
};
